import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    inheritAttrs: true
})
export default class ActionBtn extends Vue {
    @Prop()
    text: string;

    @Prop(Boolean)
    disabled: boolean;

    @Prop({ default: 'primary' })
    variant: 'primary' | 'primary-light' | 'secondary' | 'error' | 'error-light' | 'transparent';

    @Prop()
    icon: string;

    @Prop()
    width: string;
}
